import { render } from "./HomeBody2.vue?vue&type=template&id=1326c31b&scoped=true"
import script from "./HomeBody2.vue?vue&type=script&lang=js"
export * from "./HomeBody2.vue?vue&type=script&lang=js"

import "./HomeBody2.vue?vue&type=style&index=0&id=1326c31b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1326c31b"]])

export default __exports__